<template>
  <div class="index">
    <!-- <Header ref="header" title="注册" :back="true" left="" /> -->
    <div class="windowmain" >
        <!-- <div v-html="htmlContent"></div> -->
        <iframe :src="href+'/userserver/rest/mobileTerminal/retrieveName/etps'" width="100%" height="100%"></iframe> 
 
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import {
  Form,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Field,
  Col,
  Row,
  Button,
  Picker,
  Popup,
  Toast,
  DatetimePicker,
  NoticeBar,
  Checkbox,
  CheckboxGroup,
  Dialog,
} from "vant";
const getWindowSize = function() {
  this.windowSize = this.$refs.windowmain.offsetHeight;
  console.log(this.windowSize,121222)
};
export default {
  name: "restNamelegalperson",
  data() {
    return {
      statusBar: 0,
      dynamicTop: { top: "" },
      certName: "",
htmlContent:'',
windowSize:'',
      acceptNotification: false,
      showOrginType: false,
    };
  },
  computed:{
    href(){
      return window.location.origin
    }
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
    // this.dynamicTop.top = this.$refs.header.$el.offsetHeight + "px";
    // fetch('http\x3A\x2F\x2Flocalhost\x3A8588\x2Fuserserver\x2Fuser/userEtpsRegister/MngRegister')
    // .then(response => response.text())
    // .then(html => {
    //   this.htmlContent = html
    // })
    //  this.getWindowSize();
  },

  methods: {
    getWindowSize,
    funClick() {
      if (!this.acceptNotification) {
        //	window.location.href="http\x3A\x2F\x2Flocalhost\x3A8588\x2Fuserserver\x2Fuser/userEtpsRegister/MngRegister";
        Dialog.alert({
          title: "提示",
          message: "请先勾选已阅读上述提示",
          messageAlign: "center",
        });
        return;
      }
      window.location.href="http\x3A\x2F\x2Flocalhost\x3A8588\x2Fuserserver\x2Fuser/userEtpsRegister/MngRegister";
    
      // this.$router.zshgReplace({
      //   path: '/declare',
      // });
      // this.isBlock = false;
    },
  },

  beforeRouteLeave(to, from, next) {
    if (to.path == '/resetNameIndex') {
        let that = this
        Dialog.confirm({
          message: "操作未完成，是否退出？",
          theme: "round-button",
        }).then(() => {
          next()
        })
        .catch(() => {
          next(false) 
          Dialog.close();
        });
      }else{
        next()
      }
  },

  components: {
    Header,
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [DatetimePicker.name]: DatetimePicker,
    [NoticeBar.name]: NoticeBar,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Dialog.name]: Dialog,
  },
};
</script>

<style scoped lang="scss">
@import "@/views/css/userindex.scss";
.windowmain {
  width: 100%;
  height: 100vh;
  background: #fff;
}
</style>